import React from 'react';
import { useNavigate } from 'react-router-dom';
import NavBar from '@/components/NavBar';
import { Button } from '@/components/ui/button';
import { Check } from 'lucide-react';

const ThankYouFeedback = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      <NavBar />
      
      <div className="pt-32 pb-24 px-6 max-w-3xl mx-auto flex flex-col items-center justify-center text-center">
        <div className="w-20 h-20 bg-[#111111] flex items-center justify-center mb-10 shadow-xl relative">
          <div className="absolute top-0 left-0 w-full h-full border border-stone-200 translate-x-2 translate-y-2 pointer-events-none" />
          <Check className="w-10 h-10 text-white" strokeWidth={3} />
        </div>
        
        <h1 className="font-serif text-5xl md:text-6xl text-[#111111] tracking-tight mb-6">
          Thank you.
        </h1>
        
        <p className="text-stone-600 font-medium text-lg leading-relaxed max-w-xl mx-auto mb-16">
          Your feedback has been successfully submitted to your styling team. We will use these insights to curate your upcoming lookbook.
        </p>
        
        <Button
          onClick={() => navigate('/dashboard')}
          className="rounded-none h-14 px-12 bg-white text-[#111111] border-2 border-[#111111] hover:bg-[#111111] hover:text-white font-bold uppercase tracking-[0.3em] text-[11px] transition-all"
        >
          Return to Dashboard
        </Button>
      </div>
    </div>
  );
};

export default ThankYouFeedback;
